import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trip-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "trip-page__title" }, "Текущие", -1)
const _hoisted_4 = { class: "foterBlock" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubHeader = _resolveComponent("SubHeader")
  const _component_NowTripsList = _resolveComponent("NowTripsList")
  const _component_TableTrip = _resolveComponent("TableTrip")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_CommonFooter = _resolveComponent("CommonFooter")
  const _component_trip_order_modal = _resolveComponent("trip-order-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SubHeader, { openOrderModal: _ctx.openOrderModal }, null, 8, ["openOrderModal"]),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_NowTripsList, { trips: _ctx.tripList }, null, 8, ["trips"]),
      _createVNode(_component_TableTrip, {
        trips: _ctx.tripList,
        sort: _ctx.sort,
        orderBy: _ctx.orderBy,
        orderDir: _ctx.orderDir
      }, null, 8, ["trips", "sort", "orderBy", "orderDir"]),
      _createVNode(_component_Paginator, {
        rows: _ctx.perPage,
        totalRecords: _ctx.tripCount,
        onPage: _cache[1] || (_cache[1] = $event => (_ctx.onPage($event)))
      }, null, 8, ["rows", "totalRecords"]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_CommonFooter)
      ])
    ]),
    _createVNode(_component_trip_order_modal, {
      showOrderModal: _ctx.showOrderModal,
      closeModal: _ctx.closeOrderModal,
      orderTypeId: _ctx.orderTypeId
    }, null, 8, ["showOrderModal", "closeModal", "orderTypeId"])
  ]))
}